export const DEFAULT_DPR = [1, 2, 3, 4, 5];

// default quality parameter values mapped by each dpr srcset entry
export const DPR_QUALITIES = {
  1: 75,
  2: 50,
  3: 35,
  4: 23,
  5: 20
};

// default tolerable percent difference between srcset pair widths
export const DEFAULT_SRCSET_WIDTH_TOLERANCE = 0.08;
// minimum generated srcset width
export const MIN_SRCSET_WIDTH = 100;
// maximum generated srcset width
export const MAX_SRCSET_WIDTH = 8192;